// Shared `accept` value for document/attachment file inputs so the comment
// thread and every document upload offer the same set of types. Covers images
// (compliance photos/scans) plus PDF, Word, Excel and PowerPoint.
//
// `accept` is only a picker hint, but uploads go direct-to-storage via presigned
// PUT and Supabase Storage enforces its own per-bucket `allowed_mime_types`. This
// list MUST stay in sync with the `compliance-documents` and `submission-files`
// bucket allowlists (see migration 0050) — otherwise a type offered here is
// rejected at upload time with an HTTP 400.
export const DOCUMENT_ACCEPT =
  'image/*,application/pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx';
